import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Esto reemplaza al médico?',
    answer: 'No. PequeSalud Natural es un sistema de apoyo natural complementario. Siempre incluye señales claras de cuándo ir al médico — esa es parte de su valor.'
  }, {
    question: '¿Para qué edades sirve?',
    answer: 'Los protocolos están diseñados para síntomas infantiles comunes. Siempre se recomienda consultar con el profesional de salud de tu familia para casos específicos.'
  }, {
    question: '¿Cómo accedo después de comprar?',
    answer: 'Acceso digital inmediato. Recibes el link en tu correo en minutos. Lo abres desde cualquier dispositivo (celular, tablet o computadora).'
  }, {
    question: '¿Y si no me sirve?',
    answer: '7 días de garantía total. Te devuelvo el dinero sin preguntas ni formularios. El riesgo es completamente mío.'
  }, {
    question: '¿Solo funciona si tengo ingredientes especiales?',
    answer: 'Todo lo que necesitas ya lo tienes en casa o lo encuentras en cualquier tienda de tu barrio. Sin compras especiales ni ingredientes difíciles de conseguir.'
  }];
  return <section className="py-24 bg-white" data-id="element-75">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="text-center mb-16" data-id="element-77">
          <div className="inline-flex items-center justify-center p-3 bg-cream rounded-full mb-6" data-id="element-78">
            <HelpCircle className="h-6 w-6 text-terracotta" data-id="element-79" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4 font-serif" data-id="element-80">
            Preguntas Frecuentes
          </h2>
          <p className="text-forest/60" data-id="element-81">
            Todo lo que necesitas saber antes de empezar
          </p>
        </div>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.question} answer={faq.answer} data-id="element-83" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-sage/20 rounded-xl overflow-hidden bg-cream/30 hover:bg-cream/50 transition-colors" data-id="element-84">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-85">
        <span className="font-bold text-forest text-lg pr-8" data-id="element-86">{question}</span>
        <ChevronDown className={`h-5 w-5 text-terracotta transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-87" />
      </button>
      <AnimatePresence data-id="element-88">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-89">
            <div className="px-6 pb-6 text-forest/80 leading-relaxed border-t border-sage/10 pt-4" data-id="element-90">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}